import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProductPrice } from "src/api/types";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";
import ProductSelection from "src/pages/Onboarding/Payment/components/ProductSelection";

interface ProductHeaderProps {
  header: string;
  subHeader: string | null;
}

const ProductHeader = ({ header, subHeader }: ProductHeaderProps) => {
  const isMobile = useIsMobile();

  return (
    <Stack gap={1}>
      <Typography variant={isMobile ? "h6" : "h5"} fontWeight={600}>
        {header}
      </Typography>
      {subHeader != null ? (
        <Typography variant={isMobile ? "body2" : "body1"}>
          {subHeader}
        </Typography>
      ) : null}
    </Stack>
  );
};

interface Props {
  page: string;
  selectedProduct?: ProductPrice;
  handleProductChange: (product: ProductPrice) => void;
  discountedPrice?: string;
  products: ProductPrice[];
  form?: string;
  count?: number;
}

const ProductsDisplay = ({
  page,
  selectedProduct,
  handleProductChange,
  discountedPrice,
  products,
  form,
  count,
}: Props) => {
  const { t } = useTranslation();
  const shippingComponent = "shipping";
  const productSlug = useProduct((p) => p.slug);

  const header = useMemo(() => {
    return t(`${page}.${shippingComponent}.${productSlug}.header`);
  }, [page, productSlug, t]);

  const subHeader = useMemo(() => {
    if (["iwl-ot", "db-ot", "cv-ot"].includes(productSlug)) {
      return t(`${page}.${shippingComponent}.${productSlug}.subHeader`);
    }

    return null;
  }, [page, productSlug, t]);

  return (
    <Stack gap={3}>
      <ProductHeader header={header} subHeader={subHeader} />
      {products?.map((p) => {
        return (
          <ProductSelection
            key={p.stripe_id}
            item={p}
            selectedItem={selectedProduct}
            onChange={handleProductChange}
            page={page}
            prescribedPrice={discountedPrice}
            form={form}
            count={count}
          />
        );
      })}
    </Stack>
  );
};

export default ProductsDisplay;
